import { Injectable } from '@angular/core';
import { AppConfigService } from '../app-config.service.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SalesleadService {

  uri = '';
  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    this.uri = this.appConfigService.apiBaseUrl;
  }
  GetSalesLeadCompetitor() {
    return this.http.post<any>(`${this.uri}/SalesLeadCompetitor`, {});
  }
  get(model) {
    return this.http.post<any>(`${this.uri}/SalesLead`, model);
  }

  getSales() {
    return this.http.post<any>(`${this.uri}/SalesLead`, {});
  }

  getUrl() {
    return `${this.uri}/SalesLead`;
  }

  getSalesLeadStatus() {
    return this.http.post<any>(`${this.uri}/ProjectSalesLeadStatus`, {});
  }

  getSalesLeadFollowUpStatus() {
    return this.http.post<any>(`${this.uri}/SalesLeadFollowUpStatus`, {});
  }

  getSalesLeadRating() {
    return this.http.post<any>(`${this.uri}/SalesLeadRating`, {});
  }

  getSalesLeadByField(model) {
    return this.http.post<any>(`${this.uri}/SalesLead/GetSalesLeadByField/`, model);
  }

  updateLeadStatusById(leadid, statusid) {
    return this.http.post<any>(`${this.uri}/SalesLead/UpdateLeadStatusById/`, {salesleadid: leadid, leadstatus: statusid});
  }
  updateLeadFollowStatusById(leadid, statusid) {
    return this.http.post<any>(`${this.uri}/SalesLead/UpdateLeadFollowStatusById/`, {salesleadid: leadid, leadfollowupstatus: statusid});
  }

  updateLeadFollowRatingById(leadid, statusid) {
    return this.http.post<any>(`${this.uri}/SalesLead/UpdateLeadFollowRatingById/`, {salesleadid: leadid, leadrating: statusid});
  }

  deleteSalesLead(id){
    return this.http.post<any>(`${this.uri}/SalesLead/DeleteSalesLead`, {Id: id});
  }
}
